<div class="volver-arriba" *ngIf="visible">
  <button
    (click)="goTop()"
    class="volver-arriba-govco ml-5"
    aria-describedby="descripcionId"
    aria-label="Volver arriba"
  ></button>
</div>
